module.exports = __webpack_public_path__ + "static/media/icons-phone.491d26a2.svg";